import { APPConstants } from '../constants/app';

function useEnvironment () {

    const isProduction = () => {
        return window.location.hostname.includes(
            APPConstants.PRODUCTION_HOSTNAME
        );
    }

    return {
        isProduction
    };
}

export default useEnvironment;
